export * from './content-type-badge.component';


// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-type-badge/index.ts